// SPDX-FileCopyrightText: 2024 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import React from 'react';
import { Color } from '@tls/sw91-communication/types/com.base';
import { getColorOption } from 'components/common/ColorOptions';
import styled from 'styled-components';
import { Colors, Skeleton } from '@tls/treact-ui';

interface Props {
  size;
  isUsedLabel: boolean;
  labelColor: Color | undefined;
  isLoading?: boolean;
}

const LabelColorRect = ({ size, isUsedLabel, labelColor, isLoading }: Readonly<Props>) => {
  if (isLoading) {
    return (
      <SkeletonWrapper>
        <Skeleton variant='rect' animation height={size} width={size} />
      </SkeletonWrapper>
    );
  }
  return <LabelColorRectLoaded $size={size} $isUsedLabel={isUsedLabel} $labelColor={labelColor} />;
};
const SkeletonWrapper = styled.div`
  margin: 0.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const LabelColorRectLoaded = styled.div<{ $size; $isUsedLabel: boolean; $labelColor: Color | undefined }>`
  background-color: ${props =>
    props.$isUsedLabel ? `rgb(${getColorOption(props.$labelColor).id})` : Colors.trgrey2.hex};
  width: ${props => props.$size};
  height: ${props => props.$size};
  margin: 0.25rem;
`;

export default LabelColorRect;
